import { Text, Title } from './../../Typography';
import Link from 'next/link';
import { FC } from 'react';
import { ContainerListing, ContainerSubline, ImageContainer, MarketChip } from './style';
import { getCopy } from 'lib/utils/getCopy';
import { DictionaryItem } from "../../../types/Dictionary";
import { CorporateButton } from './../../CorporateButton';
import { MobileDownloadIcon, RightArrowIcon } from '../../Icons/icons';

export interface PressReleaseAlgolia {
  id: string;
  title: string;
  slug: string;
  teaser: string;
  downloadPr: { url: string };
  image: any;
  publishedAt: string;
  topicEnum: string;
  market: string;
}

interface PressListingPageProps {
  item: any;
  copy: DictionaryItem[];
}

function DesktopDownloadIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.6681 10.271C17.819 10.4001 17.819 10.6583 17.6681 10.8197L12.2414 16.6245C12.0905 16.7859 11.8793 16.7859 11.7284 16.6245L6.30172 10.8197C6.15086 10.6583 6.15086 10.4001 6.30172 10.271L6.90517 9.62551C7.02586 9.46414 7.26724 9.46414 7.4181 9.62551L11.1853 13.7843V3.3873C11.1853 3.19365 11.3664 3 11.5474 3H12.3922C12.6034 3 12.7543 3.19365 12.7543 3.3873V13.7843L16.5517 9.62551C16.7026 9.46414 16.944 9.46414 17.0647 9.62551L17.6681 10.271Z"
        fill="#292B29"
      />
      <path
        d="M4.36207 19.3217H19.6379C19.6379 19.3217 20 19.5154 20 19.709V20.6127C20 20.8386 19.819 21 19.6379 21H4.36207C4.15086 21 4 20.8386 4 20.6127V19.709C4 19.5154 4.15086 19.3217 4.36207 19.3217Z"
        fill="#292B29"
      />
    </svg>
  );
}

const PressListingPageListItem: FC<PressListingPageProps> = ({ item, copy }) => {
  const publishedAt = new Date(item.date);

  const SubLine = <>
    <div className='w-4/12 mb-3 md:mb-0 text-left'>
      <MarketChip type={'leadxs'} tag="span" className={`inline ${item.market === 'global' ? 'bg-corporate-lightBlue' : 'bg-corporate-peach'}`}>
        {getCopy(`market_${item.market}`, copy)}
      </MarketChip>
    </div>
    <Text type={'leadxs'} tag="p" className='text-left py-1 md:ml-3 mb-5 md:mb-0'>
      {`${publishedAt.getDate()}.${publishedAt.getMonth() + 1}.${publishedAt.getFullYear()}`} •{' '}
      {getCopy(`press_tag_${item.topicEnum}`, copy)}
    </Text>
  </>;
  return (
    <ContainerListing>
      <div className="w-full md:flex md:flex-wrap">
        <div className='flex w-full hidden md:flex mb-4'>
          {SubLine}
        </div>
        <div className='flex w-full flex-col md:flex-row'>
          {item.image && (
            <ImageContainer className="w-full mb-4 md:mb-0">
              <img
                src={item.image.url}
                alt={item.title as string}
                className="object-cover w-full h-full rounded-lg"
              />
            </ImageContainer>
          )}
          <div className='w-full md:hidden'>
            {SubLine}
          </div>
          <div className="w-full md:ml-3">
            <Link href={`/press/${item.slug}`} passHref className='mb-2.5'>

              <Title tag="h2" type="xs">
                {item.title}
              </Title>

            </Link>
            {item.teaser && (
              <Text type="md" tag="p">
                {item.teaser}
              </Text>
            )}
            <div className='mt-6'>
              <Link href={`/press/${item.slug}`} passHref>

                <Text tag="span" type="link" className="flex items-center block">
                  {getCopy('read_more', copy)}
                  <RightArrowIcon className="ml-4 h-6" />
                </Text>

              </Link>
            </div>
          </div>
        </div>


      </div>
    </ContainerListing >
  );
}

export default PressListingPageListItem;
